import { CONFIRM_KEYS } from "@inputs/text/EmailField/constants";
import type { SxProps } from "@mui/material";
import Autocomplete, { autocompleteClasses } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import type { Theme } from "@mui/material/styles";
import { type Control, Controller } from "react-hook-form";
import type { TCandidateData } from "./types";

export interface IRecipientsForm {
  recipients: TCandidateData[];
}

export interface IRecipientsProps {
  label: string;
  getOptionDisabled: (candidate: TCandidateData) => boolean;
  control: Control<IRecipientsForm, void>;
  candidates: readonly TCandidateData[];
  sx?: SxProps<Theme>;
}

export const Recipients = ({ label, getOptionDisabled, control, candidates, sx }: IRecipientsProps) => {
  return (
    <Controller
      control={control}
      name="recipients"
      render={({ field: { value, onChange, name, ref }, fieldState: { error } }) => (
        <Autocomplete
          fullWidth
          value={value}
          disabled={candidates.length === 1}
          onChange={(_, value) => onChange(value)}
          options={candidates}
          getOptionLabel={(option) => `${option.firstName} ${option.lastName}`}
          isOptionEqualToValue={(option, value) => option._id === value._id}
          onKeyDown={(event) => {
            if (CONFIRM_KEYS.includes(event.key)) {
              event.preventDefault();
              event.stopPropagation();
            }
          }}
          getOptionDisabled={getOptionDisabled}
          renderOption={(props, option) => (
            <li data-hj-suppress="true" {...props}>
              {option.firstName} {option.lastName}
            </li>
          )}
          renderInput={(params) => (
            <TextField
              {...params}
              name={name}
              label={label}
              inputRef={ref}
              error={Boolean(error)}
              helperText={error?.message}
              size="small"
              sx={sx}
              data-hj-suppress="true"
            />
          )}
          limitTags={6}
          multiple
          slotProps={{
            chip: {
              color: "yellow",
              size: "small",
              sx: { [`&.${autocompleteClasses.tag}`]: { mt: "1px", mb: 0 } },
            }
          }}
        />
      )}
    />
  );
};
